import React from 'react';

const IconLetter = ({ style }) => (
  <svg
    width="64"
    height="64"
    className={style}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="32" fill="white" />
    <path
      d="M41.8906 22.8594H22.1094C20.9477 22.8594 20 23.8061 20 24.9688V39.0312C20 40.19 20.9435 41.1406 22.1094 41.1406H41.8906C43.0494 41.1406 44 40.1971 44 39.0312V24.9688C44 23.81 43.0565 22.8594 41.8906 22.8594ZM41.5993 24.2656L32.0447 33.8203L22.4075 24.2656H41.5993ZM21.4062 38.7401V25.2532L28.1787 31.9676L21.4062 38.7401ZM22.4006 39.7344L29.1773 32.9577L31.5519 35.3118C31.8267 35.5843 32.2703 35.5835 32.5441 35.3097L34.8594 32.9944L41.5994 39.7344H22.4006ZM42.5938 38.74L35.8537 32L42.5938 25.2599V38.74Z"
      fill="#394BF6"
    />
  </svg>
);

export default IconLetter;
